import { tss } from "tss-react/mui";
import { DEFAULT_LEFT_PADDING, DEFAULT_RIGHT_PADDING, MOBILE_LEFT_PADDING, MOBILE_RIGHT_PADDING, WINDOW_MAX_WIDTH } from "../../../layout/Layout.styles";

export const useStyles = tss.create(({ theme }) => ({
	root: {
		position: 'relative',
		overflow: 'hidden',
		[theme.breakpoints.down('md')]: {
			backgroundColor: '#F9F9FB',
		}
	},
	container: {
		margin: '0 auto',
		maxWidth: WINDOW_MAX_WIDTH,
		paddingLeft: DEFAULT_LEFT_PADDING,
		paddingRight: DEFAULT_RIGHT_PADDING,
		paddingBottom: 24,
		paddingTop: 48,
		overflow: 'hidden',
		'& > div': {
			textAlign: 'center',
		},
		[theme.breakpoints.down('md')]: {
			paddingLeft: MOBILE_LEFT_PADDING,
			paddingRight: MOBILE_RIGHT_PADDING,
			paddingBottom: 35,
			paddingTop: 20,
		}
	},
	tag: {
		padding: "6px 16px",
		backgroundColor: '#979797',
		borderRadius: 8,
		color: "#FFFFFF",
		cursor: 'pointer',
		// marginRight: 16,
		"& p": {
			color: "inherit",
			textTransform: 'capitalize',
			fontSize: 14,
			lineHeight: '20px',
			fontWeight: 400,
		},
		"&:hover": {
			backgroundColor: theme.palette.primary.main,
			"& p": {
				textTransform: 'capitalize',
			}
		}
	},
	active: {
		backgroundColor: theme.palette.primary.main,
	}
}))